export default __webpack_public_path__ + "static/front-cover-savannah-23dcefda00886e7c26bf9edf100d6985.png";